export type RegisterRequest = {
  firstname: string;
  lastname: string;
  password: string;
  confirmedGDPR: boolean;
};
